<script>
import Select from '@/packages/ui/components/Select/Select.vue';

export default {
  name: 'PaginationItemsCount',
  components: {
    Select,
  },
  props: {
    countItems: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      options: [10, 20, 40, 60],
    };
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
  },
  i18n: {
    messages: {
      en_US: {
        itens_per_page: 'Items per page',
      },
      es_ES: {
        itens_per_page: 'Ítems por página',
      },
      pt_BR: {
        itens_per_page: 'Itens por página',
      },
    },
  },
};
</script>

<template>
  <div class="PaginationItemsCount">
    <Select
      class="PaginationItemsCount-Select"
      data-testid="pagination-select"
      dropdown-direction="top"
      :option="countItems"
      :options="options"
      @change="handleChange"
    />
    <span class="PaginationItemsCount-Text">
      {{ $t('itens_per_page') }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.PaginationItemsCount {
  align-items: center;
  display: flex;
  gap: var(--track-spacing-sm);
}

.PaginationItemsCount-Select {
  width: 100px;
}

.PaginationItemsCount-Text {
  color: var(--track-color-bluegray-80);
  white-space: nowrap;
}
</style>
